module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/guests_lv-4f5047d9d830cee46061667ba1658cfb.png";